import React from "react";
import { connect } from 'react-redux';
import { Container, Header } from 'semantic-ui-react';
import { Helmet } from "react-helmet";


const CookiePolicy = props => (
  <div className='main-container'>
    <Helmet>
      <title>Inenco Portal | Cookie Policy</title>
    </Helmet>
    <Container text>
    <br></br>
    <div className="Container">
    <Header as='h2'>Cookie Policy</Header>
    <br></br>
      <div className="row">
        <div className="container">
          <div className="row">
            <div className="col-xs-24 text-center">
            </div>
          </div>
          <div className="row">
            <div className="col-xs-24">


              <div className="row text-row">
                <div className="col-xs-24 no-gutters">

                  <div className="text-column">

                    <p>This cookie policy applies to Inenco Group Limited (Company no. 02435678) with its registered office at Ribble House, Ballam Road, Lytham St. Annes, Lancashire, FY8 4TS (‘<strong>Inenco</strong>‘, ‘<strong>we</strong>‘, ‘<strong>our</strong>‘ or ‘<strong>us</strong>‘) and the cookies used on our website <a href="https://insite.inenco.com">insite.inenco.com</a> (‘<strong>website</strong>‘).</p>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <br></br>
    <div className="container">
      <div className="row">
        <div className="col-xs-24 text-center">
          <h2>1. INTRODUCTION</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24">


          <div className="row text-row">
            <div className="col-xs-24 no-gutters">

              <div className="text-column">

                <p>Cookies are small text files that may be stored on your computer (or other internet enabled devices, such as a smartphone or tablet) when you visit a website. They help websites remember information about your visit, like your country, language and other settings. They can also help make your next visit easier.</p>
                <p>We use cookies and other similar technologies such as marketing tags for several purposes as described more fully below, including collecting information about the number of visitors to the website and customer demographics, which is used to improve your experience of the website. Cookies may be either “persistent” cookies or “session” cookies: a persistent cookie will be stored by a web browser and will remain valid until its set expiry date, unless deleted by the user before the expiry date; a session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.</p>
                <p>If you wish to remove cookies placed on your device by our site or stop our site placing further cookies on your device you can do this at any time (learn how to do this below).</p>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>


    <br></br>
    <div className="container">
      <div className="row">
        <div className="col-xs-24 text-center">
          <h2>2. CATEGORIES OF COOKIES USED ON THIS WEBSITE AND PURPOSES</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24">


          <div className="row text-row">
            <div className="col-xs-24 no-gutters">

              <div className="text-column">

                <p></p>
                <div id="optanon-cookie-policy">
                  <p>We use the following cookies:</p>
                  <p><strong>Strictly necessary cookies.</strong></p>
                  <p>These are cookies that are required for the operation of our website.&nbsp; They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. They include, for example, cookies which help prevent security attacks, and cookies which store your cookie consent preferences. We do not require your consent to place these cookies. Nevertheless, you may be able to block these cookies yourself on your device/ browser, but restricting these cookies is likely to mean that our website will not work as you would expect and certain functionality may be inoperable.</p>
                  <p><strong>Non-essential cookies</strong></p>
                  <p><u>Analytical/performance cookies.&nbsp; </u></p>
                  <p>They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it.&nbsp; This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily.&nbsp; We use cookies to compile visitor statistics such as how many people have visited our website, how they reached our website, what type of technology they are using (e.g. Mac or Windows, which helps to identify when our website isn’t working as it should for particular technologies), how long they spend on the website, what page they look at etc. This helps us to continuously improve our website.</p>
                  <p>We have enabled Google Analytics Demographics and Optimizely on the website to allow us to review information about users of the website. We may use this information to enable us to make decisions about what information to include on the website and how to present it.</p>
                  <p>You may opt-out of tracking from Google Analytics and/or the Google Analytics Advertising features enabled on the website by refusing the use of cookies (see below), through configuring the Google Ad settings or by installing the Google Analytics Opt-out Browser Add-on.</p>
                  <p><u>Functionality cookies.&nbsp; </u></p>
                  <p>These cookies enable the website to provide enhanced functionality and personalisation and allow us to recognise you when you return to our website. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region). They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.</p>
                  <p><u>Targeting &amp; Advertising cookies.&nbsp; </u></p>
                  <p>These cookies record your visit to our website, the pages you have visited and the links you have followed.&nbsp; This information will be used by us or our advertising partners/ third parties to build a profile of interests, make our website and the advertising displayed on it (and across the internet on other sites) more relevant to your interests. If you do not allow these cookies, you will experience less targeted advertising.</p>
                  <p><u>Social Media Cookies.&nbsp; </u></p>
                  <p>So you can easily “Like”, “Follow” us, or share our content, we have included sharing buttons on our site for certain social media sites such as YouTube, LinkedIn and Twitter. These cookies are set by the third party social media sites to which they relate, including.</p>
                  <p>The privacy implications vary from social media site to social media site and will be dependent on the privacy settings you have chosen on these sites. Please refer to the relevant social media site’s privacy and cookies policy for more information.</p>
                  <p>You can find more information about the individual cookies we use and the purposes for which we use them in the table below:</p>
                  <p><strong><u>Strictly necessary</u></strong></p>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="19%"><strong>Cookie</strong></td>
                        <td width="13%"><strong>Cookie Duration</strong></td>
                        <td width="41%"><strong>Purpose</strong></td>
                        <td width="26%"><strong>More information </strong><p></p>
                          <p><strong>&nbsp;</strong></p></td>
                      </tr>
                      <tr>
                        <td width="19%">ARRAffinity</td>
                        <td width="13%">1 year</td>
                        <td width="41%">Session</td>
                        <td width="26%">This cookie is set by websites run on the Windows Azure cloud platform. It is used for load balancing to make sure the visitor page requests are routed to the same server in any browsing session.</td>
                      </tr>
                      <tr>
                        <td width="19%">ARRAffinitySameSite</td>
                        <td width="13%">1 year</td>
                        <td width="41%">Session</td>
                        <td width="26%">This cookie is set by websites run on the Windows Azure cloud platform. It is used for load balancing to make sure the visitor page requests are routed to the same server in any browsing session.</td>
                      </tr>
                      <tr>
                        <td width="19%">X-Qlik-Session-insite</td>
                        <td width="13%">1 year</td>
                        <td width="41%">Session</td>
                        <td width="26%">Use for core functions of the website. Allows user to interact with custom visualisations</td>
                      </tr>
                     
                    </tbody>
                  </table>
                  <p><strong><u>Non-essential</u></strong></p>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="20%"><strong>Cookie</strong></td>
                        <td width="12%"><strong>Cookie Duration</strong></td>
                        <td width="40%"><strong>Purpose</strong></td>
                        <td width="25%"><strong>More information </strong><p></p>
                          <p><strong>&nbsp;</strong></p></td>
                      </tr>
                  
                    
                      <tr>
                        <td width="20%">_ga (Inenco Google Analytics)</td>
                        <td width="12%">2 years</td>
                        <td width="40%">Analytical/ Statistical</td>
                        <td width="25%">Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
                      </tr>
                     
                      <tr>
                        <td width="20%">_gat (Inenco Google Analytics)</td>
                        <td width="12%">1 day</td>
                        <td width="40%">Analytical/ Statistical</td>
                        <td width="25%">Used by Google Analytics to throttle request rate</td>
                      </tr>
                     
                      <tr>
                        <td width="20%">_gid (Inenco Google Analytics)</td>
                        <td width="12%">1 day</td>
                        <td width="40%">Analytical/ Statistical</td>
                        <td width="25%">Registers a unique ID that is used to generate statistical data on how the visitor uses the website.</td>
                      </tr>
                     
                    </tbody>
                  </table>
                  <div id="ot-sdk-cookie-policy"><div className="ot-sdk-cookie-policy ot-sdk-container">
                    <h3 id="cookie-policy-title">Cookie List</h3>
                    <div id="cookie-policy-description">We use necessary (essential) cookies to make our site work. We’d also like to set optional cookies to help make your experience of our website better. We won’t set optional cookies unless you enable them. Using this tool will set a cookie on your device to remember your preferences. </div>


                    <section>
                      <h4 className="ot-sdk-cookie-policy-group">Essential</h4>
                      <p className="ot-sdk-cookie-policy-group-desc">Necessary cookies enable core functionality such as security, network management, and accessibility. You may disable these by changing your browser settings, but this may affect how the website functions.</p>


                      <table>

                        <tbody></tbody>
                      </table>
                    </section><section>
                      <h4 className="ot-sdk-cookie-policy-group">Non Essential - Analytical</h4>
                      <p className="ot-sdk-cookie-policy-group-desc">We&apos;d like to (or allow our partners to) set other (functionality and analytical) cookies to help us to improve our website by collecting and reporting information on how you use it.  </p>


                      <table>

                        <tbody></tbody>
                      </table>
                    </section><section>
                      <h4 className="ot-sdk-cookie-policy-group">Non Essential – Advertising</h4>
                      <p className="ot-sdk-cookie-policy-group-desc">We’d also like to set targeting and advertising cookies to allow us (and our partners, including social media sites) to advertise the most relevant products and services to you. </p>


                      <table>

                        <tbody></tbody>
                      </table>
                    </section></div></div></div>
                <p></p>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <br></br>
    <div className="container">
      <div className="row">
        <div className="col-xs-24 text-center">
          <h2> 3. COOKIE PREFERENCES</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24">


          <div className="row text-row">
            <div className="col-xs-24 no-gutters">

              <div className="text-column">

                <p>Please provide your consent through our pop-up banner to our use of non-essential cookies on our website. You may withdraw your consent at any point by returning to our website, clicking on our banner and unchecking the box.&nbsp; Please be aware we do not need your consent (and do not ask for it) to place strictly necessary cookies (as described above).</p>
                <p>Most browsers have cookies enabled by default. However if you don’t want to enable cookies, you’ll still be able to browse the site.</p>
                <p>If you wish to disable all cookies, you can usually opt-out by setting your browser to remove or reject browser cookies. Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary from browser to browser, and from version to version. You can however obtain up-to-date information about blocking and deleting cookies via these links:</p>
                <p>(a)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; https://support.google.com/chrome/answer/95647?hl=en (Chrome);</p>
                <p>(b)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);</p>
                <p>(c)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; http://www.opera.com/help/tutorials/security/cookies/ (Opera);</p>
                <p>(d)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies (Internet Explorer);</p>
                <p>(e)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; https://support.apple.com/kb/PH21411 (Safari); and</p>
                <p>(f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge).</p>
                <p>To learn more on how to disable cookies on your browser, please consult your browser “help” section or go to <a href="https://aboutcookies.org/">aboutcookies.org</a>.</p>
                <p>To disable specific cookies, you can opt-out using the opt-out mechanisms (on our cookie banner) and links provided in the chart above. You can also delete cookies that have already been set through your browser settings.</p>
                <p>Please note that if you choose to disable some categories of cookies that we use, you may experience reduced functionality or be prevented from using the website altogether.</p>
                <p>Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control.&nbsp; These cookies are likely to be analytical/performance cookies or targeting cookies.</p>
                <p>The setting and use of cookies (and the collection of information as a result) may also result in the processing of your personal data. If you would like more information about how Inenco uses personal data (being information which is capable of identifying an individual) generally, please see our <a href="https://www.inenco.com/privacy-policy/">privacy policy</a>. If you have any further questions, comments or requests regarding our cookies policy or how we use cookies, you can contact us by email at <a href="mailto:RiskandCompliance@inenco.com">RiskandCompliance@inenco.com</a></p>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <br></br>
    <div className="container">
      <div className="row">
        <div className="col-xs-24 text-center">
          <h2>4. CHANGES TO THIS COOKIES POLICY</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24">


          <div className="row text-row">
            <div className="col-xs-24 no-gutters">

              <div className="text-column">

                <p>Any changes to this cookies policy in the future will be posted on this page and we will take all measures reasonably necessary to communicate any changes to this cookies policy to you.&nbsp; Please check back frequently to see any updates or changes to this cookies policy. We will also bring your attention to such changes by updating our cookie banner/ pop-up.</p>
                <p>This policy was last reviewed and updated: January 2021</p>
                <br></br>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    </Container>
  </div>



);

export default connect()(CookiePolicy);